import Image from "@material-symbols/svg-500/rounded/image.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

export const EditorImageIcon = memo((props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Image });
	return <Icon />;
});
